/* eslint-disable jsx-a11y/anchor-is-valid */
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import { motion } from "framer-motion";
import primaryComponents from "../../../../components/primaryComponents";
import secondaryComponents from "../../../../components/secondaryComponents";
import useTrackItem from "./useTrackItem";
import "./TrackItem.scss";

const TrackItem = () => {
  const {
    search,
    storeList,
    isFetchingTrackItems,
    trackedItems,
    metaDetails,
    // productDetails,
    // filterByVariant,
    filterByStatus,
    filterByStore,
    gotoPage,
    searchTrackItem,
  } = useTrackItem();

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Track Inventory Item Numbers"
      description="View all inventory item numbers"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 0.3 } }}
          className={`${globalStyles.pageColumnGaps} trackItem`}
        >
          <div>
            <h4 className=" mb-0">Track Item</h4>
            <p>View all inventory item numbers</p>
          </div>
          {/* </div> */}

          <div className={globalStyles.rowNavigations}>
            <a
              className={`${globalStyles.rowNavigations__item} ${
                search.get("is_sold") === "false" ? globalStyles.active : ""
              }`}
              onClick={() => filterByStatus("false")}
            >
              Available Stock
            </a>
            <a
              className={`${globalStyles.rowNavigations__item} ${
                search.get("is_sold") === "true" ? globalStyles.active : ""
              }`}
              onClick={() => filterByStatus("true")}
            >
              Sold Stock
            </a>
          </div>

          <div>
            <p>{metaDetails?.total} tracking number</p>
          </div>

          {/* table section */}
          <div className={globalStyles.tableWrapper}>
            <div className={globalStyles.tableHeader}>
              <primaryComponents.SearchField
                classNames={globalStyles.searchField}
                placeholder="Search tracking code"
                trigger={(value) => searchTrackItem(value)}
                value={search.get("query") !== null ? search.get("query") : ""}
                triggerOnInput={true}
                showsearchBtn={true}
              />

              <div className="ml-auto" style={{ width: "200px" }}>
                <primaryComponents.SelectField
                  options={storeList}
                  idKey="id"
                  nameKey="name"
                  onChange={(value) => {
                    filterByStore(value);
                  }}
                  value={
                    storeList?.find(
                      (item) => `${item.id}` === search.get("store_id"),
                    )?.name || "Filter store"
                  }
                  floatError={false}
                />
              </div>
            </div>

            <secondaryComponents.LoaderHelper
              isLoading={isFetchingTrackItems}
              classNames="mt-5"
            >
              <secondaryComponents.TrackItemTable
                metaDetails={metaDetails}
                trackedItems={trackedItems}
                gotoPage={gotoPage}
              />
            </secondaryComponents.LoaderHelper>
          </div>
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};
export default TrackItem;
